export const END_POINTS = {
  login: "/v1/auth/provider/send-otp",
  verifyOtp: "/v1/auth/provider/verify-otp",
  patient: (patientId) => `/v1/patients/${patientId}`,
  vitals: (patientId) => `/v1/consultations/patients/${patientId}/vitals`,
  consultation: (consultationId) => `/v2/consultations/${consultationId}/sections`,
  vitalsRange: (patientId) =>
    `/v1/consultations/patients/${patientId}/vital-ranges`,
  medicineList: (input, type) =>
    `/v1/consultations/medicines?pageNo=1&pageSize=10&search=${input}&type=${type}`,
  allTemplates: `/v1/consultations/prescription-templates`,
  recommendedPrescription: (consultationId, type) =>
    `/v1/consultations/${consultationId}/recommended-prescription?type=${type}`,
  nextConsultationSchedule: (patientId) =>
    `/v1/consultations/patients/${patientId}/next-consultation-schedule`,
  getRecommendedAdditionalTest: (consultationId) =>
    `/v1/consultations/${consultationId}/recommended-additional-tests`,
  getFollowUpTest: (consultationId) =>
    `/v1/consultations/${consultationId}/recommended-followup-tests`,
  treatmentList: (patientId) =>
    `/v1/consultations/patients/${patientId}/treatments`,
  historyConfig: "/v1/patients/history-config",
  patientLeapScore: (patientId) => `/v1/patients/${patientId}/leap-scores`,
  patientHistory: (patientId) => `/v1/patients/${patientId}/history/blocks`,
  getRecommendedAdditionalTest: (consultationId) =>
    `/v1/consultations/${consultationId}/recommended-additional-tests`,
  getFollowUpTest: (consultationId) =>
    `/v1/consultations/${consultationId}/recommended-followup-tests`,
  treatmentList: (patientId) =>
    `/v1/consultations/patients/${patientId}/treatments`,
  billingCollectionQueue: (search = "", page = 1, size = 50, view = "outstanding", date = "", doctorId = "") =>
    `/v1/consultation-billing/collection-queue?search=${encodeURIComponent(search)}&page=${page}&size=${size}&view=${encodeURIComponent(view)}${date ? `&date=${encodeURIComponent(date)}` : ""}${doctorId ? `&doctorId=${encodeURIComponent(doctorId)}` : ""}`,
  recordOfflinePayment: (billId) => `/v1/consultation-billing/bills/${billId}/offline-payment`,
  getQueue: (date, hospitalId) =>
    `/v1/appointments/queues?date=${date}${hospitalId && hospitalId !== 'all' ? `&hospitalId=${hospitalId}` : ''}`,
  videoJoinToken: (appointmentId) => `/v1/video-consultations/appointments/${appointmentId}/join-token`,
  videoRoom: (appointmentId) => `/v1/video-consultations/appointments/${appointmentId}/room`,
  videoRecordingRetry: (appointmentId) => `/v1/video-consultations/appointments/${appointmentId}/recording-retry`,
  videoProviderJoined: (appointmentId) => `/v1/video-consultations/appointments/${appointmentId}/provider-joined`,
  getAiCards: (consultationId) => `/v1/consultations/${consultationId}/ai-cards/form`,
  confirmAiCards: (consultationId) => `/v1/consultations/${consultationId}/ai-cards/confirm`,
  confirmAiCard: (consultationId, cardType) => `/v1/consultations/${consultationId}/ai-cards/confirm`,
  saveAiCards: (consultationId) => `/v1/consultations/${consultationId}/ai-cards`,
  registerDeviceToken: `/v1/devices`,
  checkInAppointment: (appointmentId) => `/v1/appointments/${appointmentId}/check-in`,
  reorderAppointmentQueue: (appointmentId) => `/v1/appointments/${appointmentId}/queue/reorder`,
  cancelAppointments: `/v1/appointments/cancel`,
  doctorSlots: (date, pageNo, pageSize, hospitalId) => {
    let url = `/v1/appointments/doctor-slots?date=${date}`;
    if (typeof pageNo === 'string' && (pageSize === undefined || typeof pageSize !== 'number')) {
      if (pageNo && pageNo !== 'all') {
        url += `&hospitalId=${pageNo}`;
      }
      return url;
    }
    if (pageNo !== undefined && pageNo !== null) {
      url += `&pageNo=${pageNo}`;
    }
    if (pageSize !== undefined && pageSize !== null) {
      url += `&pageSize=${pageSize}`;
    }
    if (hospitalId && hospitalId !== 'all') {
      url += `&hospitalId=${hospitalId}`;
    }
    return url;
  },
  createConsulation: `/v1/consultations`,
  searchPatient: (patientName) =>
    `/v1/patients?pageNo=1&pageSize=10&search=${patientName}`,
  createAppointment: `/v1/appointments`,
  vitalUpdate: (consultationId) => `/v1/consultations/${consultationId}/vitals`,
  updateConsultation: (consultationId) => `/v2/consultations/${consultationId}/sections`,
  testList: (patientId) => `/v1/tests/patients/${patientId}`,
  submitTestResponse: (testId) => `/v1/tests/${testId}`,
  getTreatment: (consultationId) =>
    `/v1/consultations/${consultationId}/treatment-details`,
  createUpdateTreatment: (consultationId) =>
    `/v1/consultations/${consultationId}/treatments/create-or-update`,
  endConsultation: (consultationId) =>
    `/v1/consultations/${consultationId}/end`,
  createPrescription: `/v1/consultations/prescriptions`,
  getSavedPrescription: (consultationId) =>
    `/v1/consultations/${consultationId}/prescriptions`,
  lifestyleCharts: (patientId) => `/v1/patients/${patientId}/lifestyle-charts`,
  recommendedDietPlan: (consultationId) =>
    `/v1/consultations/${consultationId}/recommended-diet-plan`,
  recommendedLifestyle: (consultationId) =>
    `/v1/consultations/${consultationId}/recommended-lifestyle`,
  emotionCharts: (patientId) => `/v1/patients/${patientId}/emotion-charts`,
  physicalFitness: (patientId) =>
    `/v1/patients/${patientId}/physical-activity-details`,
  visitsCharts: (patientId) =>
    `/v1/patients/${patientId}/consultation-adherence`,
  weightGainChart: (patientId) => `/v2/patients/${patientId}/weight-gain-chart`,
  getComplaintList: `/v1/hospitals/complaints`,
  getRiskList: `/v1/hospitals/risks`,
  patientComplaints: (patientId, status) => `/v1/patients/${patientId}/complaints?status=${status}`,
  patientRisks: (patientId, status) => `/v1/patients/${patientId}/risks?status=${status}`,
  createComplaint: (patientId) => `/v1/patients/${patientId}/complaints`,
  createRisk: (patientId) => `/v1/patients/${patientId}/risks`,
  updateComplaint: (patientId, complaintId) => `/v1/patients/${patientId}/complaints/${complaintId}`,
  updateRisk: (patientId, complaintId) => `/v1/patients/${patientId}/risks/${complaintId}`,
  updatePatientDetails: (patientId) => `/v1/patients/${patientId}`,
  createData: `/v1/hospitals/diseases`,
  createAllergy: `/v1/hospitals/allergies`,
  getCities: `/v1/hospitals/cities`,
  recordPatientWeight: (consultationId) => `/v1/consultations/${consultationId}/record-patient-weight`,
  getPrescriptionChart: (patientId) => `/v1/patients/${patientId}/prescription-adherence`,
  getDfmrChart: (patientId) => `/v1/patients/${patientId}/dfm-chart`,
  getEmotionData: (patientId) => `/v1/patients/${patientId}/stress-recommendations`,
  createUpdatePhysical: (consultationId) =>
    `/v1/consultations/${consultationId}/recommended-physical-fitness-and-stress/create-or-update`,
  logout: "/v1/auth/logout",
  createPatient: '/v1/patients',
  changeHospital: '/v1/auth/provider/change-hospital',
  providerDetails: "/v1/providers/profile",

  getScheduleEvents: "/v1/providers/schedule/events",// done
  createScheduleEvents: "/v1/providers/schedule/events", // done
  updateScheduleEvent: (id) => `/v1/providers/schedule/events/${id}`, // done
  deleteScheduleEvent: (id) => `/v1/providers/schedule/events/${id}`, // done

  getSlotSummary: (startDate, endDate, hospitalId) =>
    `/v1/providers/schedule/slots-summary?startDate=${startDate}&endDate=${endDate}${
      hospitalId && hospitalId !== 'all' ? `&hospitalId=${hospitalId}` : ''
    }`, // done
  updateSlot: (id) => `/v1/providers/schedule/slots/${id}`, // done
  blockEntireDaySlot: `/v1/providers/schedule/slots/bulk-block`, // done

  // ----

  getUnavailability: `/v1/providers/schedule/unavailability`, // done
  postUnavailability: '/v1/providers/schedule/unavailability', //done
  deleteUnavailability: (id) => `/v1/providers/schedule/unavailability/${id}`, // done

  getAvailability: (hospitalId) =>
    hospitalId && hospitalId !== 'all'
      ? `/v1/providers/schedule/availability?hospitalId=${hospitalId}`
      : `/v1/providers/schedule/availability`, //done
  createAvailability: '/v1/providers/schedule/availability',
  updateAvailability: (id) => `/v1/providers/schedule/availability/${id}`,
  moveBulkAppointment: (fromSlotId) => `/v1/providers/schedule/slots/${fromSlotId}/bulk-move`,
  unblockEntireSlot: `/v1/providers/schedule/slots/bulk-unblock`,
  bulkCancel: (slotId) => `/v1/providers/schedule/slots/${slotId}/bulk-cancel`,
  timeLine: (hospitalId) =>
    hospitalId && hospitalId !== 'all'
      ? `/v1/providers/schedule/timeline?hospitalId=${hospitalId}`
      : `/v1/providers/schedule/timeline`,
  sendOtpToPatient: '/v1/patients/send-otp',
  verifyPatientOtp: '/v1/patients/verify-otp',
  getPatientConsultationSummaries: (patientId) => `/v1/consultations/patients/${patientId}/summary`,
  generateConsultationSummaryPdf: (consultId) => `/v1/consultations/${consultId}/summary-pdf/generate`,
  getPdfStatus: (jobId) => `/v1/consultations/summary-pdf/status/${jobId}`,
  postCondition: (consultationId) => `/v1/consultations/${consultationId}/conditions`,
  getComplaintWithCondition: () => `/v1/conditions`,
  conditionTimeline: (patientId) => `/v1/patients/${patientId}/condition-timeline`,
  patientRiskAssess: (patientId) => `/v1/patients/${patientId}/risks/assess`,
  
  preconceptionGate2: (patientId) => `/v1/patients/${patientId}/preconception/gate2`, // fixed
  preconceptionGate3: (patientId) => `/v1/patients/${patientId}/preconception/gate3`,
  preconceptionComplete: (patientId) => `/v1/patients/${patientId}/preconception/complete`,
  preconceptionGate4: (patientId) => `/v1/patients/${patientId}/preconception/gate4/decision`,
  preconceptionArtCycles: (patientId) => `/v1/patients/${patientId}/preconception/art-cycles`,
  preconceptionArtPhase: (patientId, cycleId) =>
    `/v1/patients/${patientId}/preconception/art-cycles/${cycleId}/phase`, // 
  preconceptionArtComplete: (patientId, cycleId) =>
    `/v1/patients/${patientId}/preconception/art-cycles/${cycleId}/complete`,
  preconceptionArtProtocol: (patientId, cycleId) =>
    `/v1/patients/${patientId}/preconception/art-cycles/${cycleId}/protocol-adjustments`,
  preconceptionT1Protocol: (patientId) =>
    `/v1/patients/${patientId}/preconception/t1-transition/protocol-adjustments`,
  preconceptionT1: `/v1/preconception-intake/t1-transition`,
  preconceptionProtocol: (mode) =>
    `/v1/preconception-intake/protocol-adjustments${mode ? `?mode=${mode}` : ""}`, //
};